import React from "react";
import Select, { SelectOption } from "../../../common/Select";

interface BaseFieldProps {
  label: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  className?: string;
}

interface TextFieldProps extends BaseFieldProps {
  value?: string;
  type?: "text" | "email" | "number" | "date";
  placeholder?: string;
  maxLength?: number;
  min?: number;
  onBlur?: () => void;
  onChange: (value: string) => void;
}

export const TextField: React.FC<TextFieldProps> = ({
  label,
  value,
  onChange,
  required,
  disabled,
  error,
  type = "text",
  placeholder,
  maxLength,
  min,
  onBlur,
  className = "",
}) => (
  <div className={className}>
    <label className="block text-xs font-semibold text-[var(--color-text-primary)] mb-[7px]">
      {label}
      {required && <span className="text-[var(--color-error)]"> *</span>}
    </label>
    <input
      type={type}
      value={value ?? ""}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      maxLength={maxLength}
      min={type === "number" ? min : undefined}
      disabled={disabled}
      required={required}
      onBlur={onBlur}
      className={`w-full h-[44px] px-[14px] text-sm rounded-[11px] transition-all duration-200 placeholder:text-[var(--color-text-placeholder)] outline-none ${
        disabled
          ? "bg-[var(--color-bg-disabled)] text-[var(--color-text-disabled)] cursor-not-allowed"
          : error
            ? "bg-surface border border-[var(--color-error)] shadow-[0_0_0_3px_var(--color-error-light)] text-[var(--color-text-primary)]"
            : "bg-[var(--color-bg-muted)] border border-[var(--color-border-primary)] text-[var(--color-text-primary)] hover:border-[var(--color-border-input-hover)] focus:border-[var(--color-border-focus)] focus:shadow-[0_0_0_3px_var(--color-focus-ring)]"
      }`}
    />
    {error && <p className="mt-1 text-xs text-[var(--color-error)]">{error}</p>}
  </div>
);
interface SelectFieldProps extends BaseFieldProps {
  value?: string;
  options: SelectOption[];
  onChange: (value: string) => void;
  clearable?: boolean;
  onBlur?: () => void;
  searchable?: boolean;
}

export const SelectField: React.FC<SelectFieldProps> = ({
  label,
  value,
  options,
  onChange,
  required,
  disabled,
  error,
  clearable,
  searchable,
  onBlur,
  className = "",
}) => (
  <div className={className}>
    <Select
      label={label}
      value={value ?? ""}
      options={options}
      onChange={(next) => onChange(String(next ?? ""))}
      disabled={disabled}
      required={required}
      clearable={clearable}
      searchable={searchable}
      onBlur={onBlur}
      error={error}
      className="w-full"
    />
  </div>
);
